import { t } from "i18next"
import { z } from "zod"
import { stringRequired, textAreaDefaultMaxLength } from "@/models/common"
import { Language, NutritionalCondition, ObesityTherapy, Reason } from "@/types/__generated__/union-types"

export const NutritionalCounsellingSchema = z.object({
  language: z.custom<Language>(),
  healthcareProviderId: z.string().optional(),
  treatmentUnit: stringRequired.refine((value) => Number(value) >= 1 && Number(value) <= 99, {
    message: t("common.fieldErrorList.valueInRange", { min: 1, max: 99 }),
  }),
  diagnosisCode: stringRequired,
  nutritionalConditions: z.array(z.custom<NutritionalCondition>()).min(1, {
    message: "common.fieldErrorList.requiredField",
  }),
  reason: z.custom<Reason>(),
  additionalInformation: z
    .string()
    .max(textAreaDefaultMaxLength, { message: t("common.fieldErrorList.characterLimit") })
    .nullable(),
  obesityTherapy: z.custom<ObesityTherapy>(),
  allergies: z.array(z.string()),
  conditions: z.array(z.string()),
  medicationIds: z.array(z.string()),
})

export type NutritionalCounselling = z.infer<typeof NutritionalCounsellingSchema>
